<template>
  <div v-if="show" class="agent-modal-backdrop agent-text-reply-modal-backdrop" @click.self="close">
    <div
      class="agent-modal agent-text-reply-modal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="agentTextReplyCreateTitle"
      tabindex="-1"
      @keydown.esc="close"
    >
      <div class="agent-modal-head">
        <div>
          <span class="agent-modal-kicker">Text Reply</span>
          <h5 id="agentTextReplyCreateTitle">Tambah Text Reply Baru</h5>
          <p class="agent-modal-subtitle">Buat pilihan Text Reply tanpa meninggalkan pengaturan agent.</p>
        </div>
        <button type="button" class="agent-modal-close" aria-label="Tutup" :disabled="saving" @click="close">
          <i class="fa fa-times"></i>
        </button>
      </div>

      <div class="agent-modal-body">
        <div v-if="error" class="agent-alert is-danger">
          <i class="fa fa-exclamation-circle"></i>
          <span>{{ error }}</span>
        </div>

        <div class="form-group">
          <label>Judul Text Reply <span class="text-danger">*</span></label>
          <input
            ref="title"
            v-model="title"
            type="text"
            class="form-control"
            maxlength="255"
            placeholder="Contoh: Lihat Buku Panduan"
            :disabled="saving"
            @input="onTitleInput"
          />
          <small v-if="fieldErrors.title" class="agent-field-error">{{ fieldErrors.title }}</small>
        </div>

        <div class="form-group">
          <label>Isi Pesan Text Reply <span class="text-danger">*</span></label>
          <chat-component v-model="message" @input="onMessageInput" />
          <small v-if="fieldErrors.message" class="agent-field-error">{{ fieldErrors.message }}</small>
          <small class="agent-helper">Mendukung format WhatsApp dan variabel yang tersedia di editor.</small>
        </div>

        <div class="agent-info-note">
          <i class="fa fa-info-circle"></i>
          Text Reply baru disimpan sebagai published agar langsung tersedia di dropdown.
        </div>
      </div>

      <div class="agent-modal-foot">
        <agent-button variant="secondary" size="sm" :disabled="saving" @click="close">
          Batal
        </agent-button>
        <agent-button
          variant="primary"
          size="sm"
          icon="fa fa-save"
          :loading="saving"
          :disabled="saving"
          @click="submit"
        >
          Simpan
        </agent-button>
      </div>
    </div>
  </div>
</template>

<script>
import ChatComponent from "@/views/broadcast/componentsV2/Forms/chatComponent.vue";
import AgentButton from "./AgentButton.vue";

export default {
  name: "TextReplyCreateModal",
  components: {
    ChatComponent,
    AgentButton
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    saving: {
      type: Boolean,
      default: false
    },
    error: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      title: "",
      message: "",
      fieldErrors: {
        title: "",
        message: ""
      }
    };
  },
  watch: {
    show(value) {
      if (value) {
        this.title = "";
        this.message = "";
        this.fieldErrors = { title: "", message: "" };
        this.$nextTick(() => {
          if (this.$refs.title && this.$refs.title.focus) this.$refs.title.focus();
        });
      }
    }
  },
  methods: {
    onTitleInput() {
      this.fieldErrors.title = "";
      this.$emit("clear-error");
    },
    onMessageInput() {
      this.fieldErrors.message = "";
      this.$emit("clear-error");
    },
    close() {
      if (this.saving) return;
      this.$emit("close");
    },
    validate() {
      this.fieldErrors = { title: "", message: "" };
      if (!this.title || !this.title.trim()) {
        this.fieldErrors.title = "Judul Text Reply wajib diisi.";
      }
      if (!this.message || !this.message.trim()) {
        this.fieldErrors.message = "Isi pesan Text Reply wajib diisi.";
      }
      if (this.fieldErrors.title) {
        this.$nextTick(() => {
          if (this.$refs.title && this.$refs.title.focus) this.$refs.title.focus();
        });
        return false;
      }
      if (this.fieldErrors.message) {
        const textarea = document.querySelector(".agent-text-reply-modal textarea");
        if (textarea && textarea.focus) textarea.focus();
        return false;
      }
      return true;
    },
    submit() {
      if (this.saving) return;
      if (!this.validate()) return;
      this.$emit("save", {
        title: this.title.trim(),
        message: this.message
      });
    }
  }
};
</script>

<style scoped>
.agent-modal-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1900;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(16, 24, 40, .45);
  padding: 18px;
}
.agent-modal {
  width: 100%;
  max-height: calc(100vh - 36px);
  overflow: hidden;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 24px 60px rgba(16, 24, 40, .24);
}
.agent-text-reply-modal-backdrop {
  z-index: 1900;
}
.agent-text-reply-modal {
  display: flex;
  flex-direction: column;
  max-width: 640px;
}
.agent-modal-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  border-bottom: 1px solid #edf1f6;
  padding: 16px 18px;
}
.agent-modal-kicker {
  display: block;
  color: #e77f25;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: .08em;
  text-transform: uppercase;
}
.agent-modal-head h5 {
  margin: 3px 0 0;
  color: #172033;
  font-size: 18px;
  font-weight: 800;
}
.agent-modal-subtitle {
  margin: 3px 0 0;
  color: #7b8ba3;
  font-size: 12px;
}
.agent-modal-close {
  border: 0;
  background: transparent;
  color: #98a2b3;
  font-size: 18px;
  line-height: 1;
  padding: 4px;
  cursor: pointer;
}
.agent-modal-close:disabled {
  cursor: not-allowed;
  opacity: .55;
}
.agent-modal-body {
  min-height: 0;
  flex: 1 1 auto;
  overflow-y: auto;
  padding: 16px 18px;
}
.agent-modal-body .form-group > label {
  margin-bottom: 6px;
  color: #344054;
  font-size: 13px;
  font-weight: 700;
}
.agent-modal-body .form-control {
  font-size: 13px;
}
.agent-modal-body .form-control:focus {
  border-color: #fe9b44;
  box-shadow: 0 0 0 3px rgba(254, 155, 68, .12);
}
.agent-modal-foot {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  border-top: 1px solid #edf1f6;
  padding: 12px 18px;
}
.agent-field-error {
  display: block;
  margin-top: 4px;
  color: #d92d20;
  font-size: 12px;
}
.agent-helper {
  display: block;
  margin-top: 4px;
  color: #98a2b3;
  font-size: 12px;
}
.agent-info-note {
  display: flex;
  align-items: flex-start;
  gap: 7px;
  margin-top: 12px;
  border: 1px solid #dce9ff;
  border-radius: 10px;
  background: #f5f9ff;
  color: #56708f;
  padding: 10px 11px;
  font-size: 12px;
  line-height: 1.55;
}
.agent-info-note i {
  margin-top: 2px;
  color: #2e90fa;
}
.agent-alert {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 12px;
  border-radius: 10px;
  padding: 10px 12px;
  font-size: 12px;
  line-height: 1.6;
}
.agent-alert.is-danger {
  border: 1px solid #f5c2c0;
  background: #fff6f5;
  color: #b42318;
}
@media (max-width: 575px) {
  .agent-modal-foot {
    flex-direction: column-reverse;
  }
  .agent-modal-foot .btn {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/ai/agentV2/components/TextReplyCreateModal.vue